import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Sync as SyncIcon } from "@air/next-icons";
import { memo } from "react";
export const ProcessingMessage = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "inset-x-0 top-0 flex w-full items-center bg-black py-2.5",
        children: [
            /*#__PURE__*/ _jsx(SyncIcon, {
                className: "ml-4 mr-3 block size-5 animate-spin text-white"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-14 text-white",
                children: "This video is still processing. You may experience delayed playback."
            })
        ]
    });
});
ProcessingMessage.displayName = "ProcessingMessage";
